import { useScope } from "@state/scopeContext.lib";

export type TaskTemplateMode = "orgTemplate" | "clientTemplate";

export const useTaskTemplateMode = (): TaskTemplateMode => {
    const { workspaceId } = useScope();
    return workspaceId ? "clientTemplate" : "orgTemplate";
};
